import React from 'react';


export default function UsersIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21M16 7C16 9.20914 14.2091 11 12 11C9.79086 11 8 9.20914 8 7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7Z" stroke="currentColor" strokeOpacity="0.5" strokeLinejoin="round"/>
<path d="M22 15V13.8889C22 13.2995 21.7893 12.7343 21.4142 12.3175C21.0391 11.9008 20.5304 11.6667 20 11.6667H18M18 9.44444C19.1046 9.44444 20 8.44952 20 7.22222C20 5.99492 19.1046 5 18 5" stroke="currentColor" strokeOpacity="0.5" strokeLinejoin="round"/>
<path d="M2 15V13.8889C2 13.2995 2.21071 12.7343 2.58579 12.3175C2.96086 11.9008 3.46957 11.6667 4 11.6667H6M6 9.44444C4.89543 9.44444 4 8.44952 4 7.22222C4 5.99492 4.89543 5 6 5" stroke="currentColor" strokeOpacity="0.5" strokeLinejoin="round"/>
</svg>

  )
}
